export const categories = [
  { id: 'daily', name: '日常搞笑', icon: 'ri-emotion-happy-line', desc: '生活里的小事，笑到停不下来' },
  { id: 'office', name: '职场摸鱼', icon: 'ri-briefcase-4-line', desc: '打工人的真实写照与摸鱼日常' },
  { id: 'bedtime', name: '睡前治愈', icon: 'ri-moon-line', desc: '软软的故事，陪你安心入睡' },
  { id: 'commute', name: '通勤解闷', icon: 'ri-train-line', desc: '地铁公交上的碎片快乐' },
  { id: 'campus', name: '校园生活', icon: 'ri-graduation-cap-line', desc: '回不去的青春与笑闹日常' },
  { id: 'brainstorm', name: '沙雕脑洞', icon: 'ri-lightbulb-flash-line', desc: '无厘头脑洞，越看越上头' },
];

export interface Comic {
  id: string;
  title: string;
  category: string;
  categoryName: string;
  tags: string[];
  cover: string;
  summary: string;
  views: string;
  likes: string;
  updatedAt: string;
  episode: string;
  isHot?: boolean;
  isNew?: boolean;
  editorPick?: boolean;
  readingTime: string;
}

export const comics: Comic[] = [
  {
    id: 'daling-bulide',
    title: '打工人布里的周一',
    category: 'office',
    categoryName: '职场摸鱼',
    tags: ['打工人', '摸鱼', '办公室'],
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cartoon%20illustration%20of%20a%20tired%20office%20worker%20sitting%20at%20a%20desk%20with%20a%20coffee%20mug%2C%20amusing%20expression%2C%20soft%20orange%20and%20cream%20color%20palette%2C%20chibi%20style%2C%20playful%20webtoon%20art&width=800&height=560&seq=comic-01&orientation=landscape',
    summary: '周一早晨的办公室，谁还不是个睁不开眼的打工人？布里的崩溃日常，笑点密集又真实。',
    views: '86.2万',
    likes: '3.1万',
    updatedAt: '今日更新',
    episode: '第 42 话',
    isHot: true,
    isNew: true,
    readingTime: '3分钟',
  },
  {
    id: 'maomi-xiaban',
    title: '猫咪下班后的小剧场',
    category: 'bedtime',
    categoryName: '睡前治愈',
    tags: ['猫咪', '治愈', '小剧场'],
    cover: 'https://readdy.ai/api/search-image?query=Cute%20chibi%20cat%20sitting%20on%20a%20windowsill%20watching%20sunset%2C%20cozy%20bedtime%20scene%2C%20warm%20pastel%20orange%20and%20cream%20tones%2C%20soft%20cartoon%20illustration%2C%20relaxing%20webtoon%20style&width=800&height=560&seq=comic-02&orientation=landscape',
    summary: '一只下班回家的小猫咪，用自己脑内的小剧场治愈疲惫的一天，睡前必看的柔软时光。',
    views: '59.4万',
    likes: '2.6万',
    updatedAt: '昨日更新',
    episode: '第 18 话',
    isHot: true,
    editorPick: true,
    readingTime: '4分钟',
  },
  {
    id: 'luzhuan-niwo',
    title: '社恐星人的早高峰',
    category: 'commute',
    categoryName: '通勤解闷',
    tags: ['社恐', '早高峰', '地铁'],
    cover: 'https://readdy.ai/api/search-image?query=Funny%20cartoon%20of%20an%20awkward%20commuter%20on%20a%20crowded%20subway%20train%2C%20nervous%20expression%2C%20light%20humorous%20illustration%2C%20warm%20neutral%20colors%20with%20teal%20accents%2C%20chibi%20webtoon%20style&width=800&height=560&seq=comic-03&orientation=landscape',
    summary: '当社恐遇上早高峰地铁，整个人都不好了。一份让通勤之路不再孤单的搞笑漫画。',
    views: '41.8万',
    likes: '1.9万',
    updatedAt: '3天前更新',
    episode: '第 27 话',
    readingTime: '2分钟',
  },
  {
    id: 'bana-xuesheng',
    title: '班长大人的沙雕课间',
    category: 'campus',
    categoryName: '校园生活',
    tags: ['校园', '课间', '青春'],
    cover: 'https://readdy.ai/api/search-image?query=Cheerful%20cartoon%20students%20in%20a%20classroom%20during%20break%20time%2C%20playful%20mischief%2C%20vibrant%20warm%20orange%20and%20cream%20colors%2C%20chibi%20style%20webtoon%20illustration&width=800&height=560&seq=comic-04&orientation=landscape',
    summary: '班长大人与同学们的课间十分钟，永远充满了意想不到的沙雕剧情，青春满满。',
    views: '32.6万',
    likes: '1.5万',
    updatedAt: '5天前更新',
    episode: '第 33 话',
    readingTime: '3分钟',
  },
  {
    id: 'naodong-laoban',
    title: '老板的脑洞开会',
    category: 'brainstorm',
    categoryName: '沙雕脑洞',
    tags: ['无厘头', '开会', '脑洞'],
    cover: 'https://readdy.ai/api/search-image?query=Surreal%20funny%20cartoon%20meeting%20room%20with%20employees%20and%20a%20boss%20having%20absurd%20ideas%2C%20whimsical%20comic%20style%2C%20warm%20orange%20and%20teal%20colors%2C%20playful%20chibi%20webtoon%20art&width=800&height=560&seq=comic-05&orientation=landscape',
    summary: '开会开到一半，老板的脑洞已经飞出银河系了。无厘头到极致，笑到缺氧。',
    views: '72.1万',
    likes: '3.8万',
    updatedAt: '今日更新',
    episode: '第 51 话',
    isHot: true,
    readingTime: '2分钟',
  },
  {
    id: 'meiyi-kaimen',
    title: '深夜食堂的神奇菜单',
    category: 'bedtime',
    categoryName: '睡前治愈',
    tags: ['美食', '深夜', '治愈'],
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20late%20night%20food%20stall%20with%20steaming%20bowls%20of%20noodles%2C%20warm%20amber%20light%2C%20comforting%20cartoon%20illustration%2C%20cream%20and%20orange%20palette%2C%20relaxing%20chibi%20webtoon%20style&width=800&height=560&seq=comic-06&orientation=landscape',
    summary: '深夜路边摊的每一道菜，都藏着一个温暖的小故事，治愈你饿着的胃和心。',
    views: '45.9万',
    likes: '2.2万',
    updatedAt: '1周前更新',
    episode: '第 22 话',
    editorPick: true,
    readingTime: '5分钟',
  },
  {
    id: 'mofish-dazhuji',
    title: '摸鱼大师养成记',
    category: 'office',
    categoryName: '职场摸鱼',
    tags: ['摸鱼', '职场', '攻略'],
    cover: 'https://readdy.ai/api/search-image?query=Humorous%20cartoon%20office%20worker%20secretly%20relaxing%20at%20desk%20with%20hidden%20phone%2C%20amusing%20expression%2C%20warm%20orange%20and%20cream%20webtoon%20illustration%2C%20chibi%20playful%20style&width=800&height=560&seq=comic-07&orientation=landscape',
    summary: '上班摸鱼也是一门学问。看资深摸鱼大师如何把办公室变成游乐园。',
    views: '68.3万',
    likes: '3.4万',
    updatedAt: '2天前更新',
    episode: '第 39 话',
    isHot: true,
    readingTime: '2分钟',
  },
  {
    id: 'heizi-gou',
    title: '黑仔狗狗的一天',
    category: 'daily',
    categoryName: '日常搞笑',
    tags: ['狗狗', '日常', '搞笑'],
    cover: 'https://readdy.ai/api/search-image?query=Adorable%20chibi%20black%20dog%20causing%20happy%20chaos%20at%20home%2C%20funny%20everyday%20cartoon%20scene%2C%20warm%20orange%20and%20cream%20colors%2C%20playful%20chibi%20webtoon%20art&width=800&height=560&seq=comic-08&orientation=landscape',
    summary: '养狗人都会懂的日常：拆家、抢食、撒娇一条龙，累并快乐着。',
    views: '55.7万',
    likes: '2.9万',
    updatedAt: '今日更新',
    episode: '第 46 话',
    isHot: true,
    readingTime: '3分钟',
  },
  {
    id: 'tongqin-lingshi',
    title: '通勤零食大作战',
    category: 'commute',
    categoryName: '通勤解闷',
    tags: ['零食', '通勤', '脑洞'],
    cover: 'https://readdy.ai/api/search-image?query=Funny%20cartoon%20commuter%20snacking%20on%20a%20bus%2C%20snacks%20flying%20around%2C%20whimsical%20comic%20style%2C%20warm%20orange%20teal%20and%20cream%20palette%2C%20playful%20chibi%20webtoon%20illustration&width=800&height=560&seq=comic-09&orientation=landscape',
    summary: '通勤路上嘴不能停！一份关于零食、地铁与奇奇怪怪脑洞的漫画合集。',
    views: '28.9万',
    likes: '1.2万',
    updatedAt: '1周前更新',
    episode: '第 15 话',
    readingTime: '2分钟',
  },
  {
    id: 'tongzhuo-shangke',
    title: '同桌的偷吃教室',
    category: 'campus',
    categoryName: '校园生活',
    tags: ['同桌', '教室', '青春'],
    cover: 'https://readdy.ai/api/search-image?query=Playful%20cartoon%20students%20secretly%20eating%20snacks%20in%20classroom%2C%20hiding%20from%20teacher%2C%20vibrant%20warm%20colors%2C%20chibi%20style%20webtoon%20illustration%2C%20cream%20and%20orange%20tones&width=800&height=560&seq=comic-10&orientation=landscape',
    summary: '教室后排的零食暗战，同桌之间永远有一场悄悄话与偷吃大戏。',
    views: '37.4万',
    likes: '1.7万',
    updatedAt: '4天前更新',
    episode: '第 28 话',
    readingTime: '3分钟',
  },
  {
    id: 'tieguai-konglong',
    title: '会说话的霸王龙',
    category: 'brainstorm',
    categoryName: '沙雕脑洞',
    tags: ['恐龙', '脑洞', '穿越'],
    cover: 'https://readdy.ai/api/search-image?query=Funny%20cartoon%20talking%20t-rex%20dinosaur%20in%20modern%20city%2C%20absurd%20humorous%20scene%2C%20warm%20orange%20and%20cream%20colors%2C%20playful%20chibi%20webtoon%20art%2C%20whimsical%20style&width=800&height=560&seq=comic-11&orientation=landscape',
    summary: '一只穿越到现代的霸王龙，用它的神逻辑把整个城市搅得天翻地覆。',
    views: '49.2万',
    likes: '2.4万',
    updatedAt: '今日更新',
    episode: '第 36 话',
    isNew: true,
    readingTime: '2分钟',
  },
  {
    id: 'zaoshang-wuwu',
    title: '早上起床气大作战',
    category: 'daily',
    categoryName: '日常搞笑',
    tags: ['起床', '日常', '搞笑'],
    cover: 'https://readdy.ai/api/search-image?query=Relatable%20funny%20cartoon%20of%20a%20sleepy%20person%20struggling%20to%20wake%20up%20in%20bed%2C%20morning%20grogginess%2C%20warm%20sunrise%20orange%20and%20cream%20colors%2C%20chibi%20webtoon%20style%20illustration&width=800&height=560&seq=comic-12&orientation=landscape',
    summary: '每天和起床气做斗争的你，看完这套漫画可能会笑出起床气。',
    views: '63.8万',
    likes: '3.0万',
    updatedAt: '2天前更新',
    episode: '第 44 话',
    isHot: true,
    editorPick: true,
    readingTime: '3分钟',
  },
];

export const recommendations = ['通勤解闷', '睡前治愈', '沙雕脑洞'];

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(cat: string): Comic[] {
  if (!cat || cat === 'all') return comics;
  return comics.filter((c) => c.category === cat);
}

export function getRelatedComics(current: Comic, limit = 3): Comic[] {
  return comics
    .filter((c) => c.id !== current.id)
    .sort((a, b) => {
      const aScore = (a.category === current.category ? 2 : 0) + (a.tags.some((t) => current.tags.includes(t)) ? 1 : 0);
      const bScore = (b.category === current.category ? 2 : 0) + (b.tags.some((t) => current.tags.includes(t)) ? 1 : 0);
      return bScore - aScore;
    })
    .slice(0, limit);
}